import React, { useState } from 'react';
import PropTypes from 'prop-types';

import { faCirclePlus } from '@fortawesome/pro-regular-svg-icons';

import { Button } from 'components/ui/button';
import Modal from './modal';

const GhostAddControl = props => <Button icon={faCirclePlus} size="sm" variant="ghost" {...props} />;

export default function AddCriticalDate({
  addCriticalDate,
  className,
  deal,
  displayAs,
  fields,
  setCriticalDate,
}) {
  const [showModal, setShowModal] = useState();
  const AddComponent = displayAs || GhostAddControl;

  return <React.Fragment>
    <AddComponent aria-label="Add critical date" className={className} onClick={() => setShowModal(true)}>
      Add critical date
    </AddComponent>

    <Modal
      addCriticalDate={addCriticalDate}
      deal={deal}
      fields={fields}
      setCriticalDate={setCriticalDate}
      show={showModal}
      onHide={() => setShowModal(false)}
    />
  </React.Fragment>;
}

AddCriticalDate.propTypes = {
  addCriticalDate: PropTypes.func,
  className: PropTypes.string,
  deal: PropTypes.object,
  displayAs: PropTypes.elementType,
  fields: PropTypes.object,
  setCriticalDate: PropTypes.func,
};
